<template>
  <button
    class="flex relative pl-8 px-2 py-1.5 gap-1 hover:bg-neutral-100 dark:hover:bg-neutral-800 rounded cursor-default select-none"
  >
    <span
      v-if="$slots.icon"
      class="absolute left-4 top-1/2 -translate-x-1/2 -translate-y-1/2"
    >
      <slot name="icon"></slot>
    </span>
    <span class="text-left">
      <slot></slot>
    </span>
  </button>
</template>
